<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Purge Customer</h4>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-sm-6 mvd_form-group">
            <customer-search-bar [label]="'Customer'" [autoHideSearch]="true" [customerNumberId]="customerNumberId"
                                 [hideUntilLoaded]="!!customerNumberId" [includeDeceased]="false"
                                 (onItemSelected)="customerSelected($event)">
            </customer-search-bar>
        </div>
    </div>
    <div class="mvd_alert--label" *ngIf="showMessage">
        Cannot Purge the Real Customer.
    </div>
    <div class="mvd_alert--satisfied" *ngIf="showSuccessMessage">
        Successfully Queued the Customer for Purge.
    </div>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" (click)="cancel()">Cancel</button>
        <mvm-spinner-btn *ngIf="true" [btnText]="'Purge'" [isLoading]="false"
                         (clicked)="purgeCustomer()" [isDisabled]="isDisable">
        </mvm-spinner-btn>
    </div>
</div>